import styles from "./Skeleton.module.css";

/**
 * A loading placeholder. It is decorative: the surrounding region owns the accessible
 * loading message, so assistive technology hears one clear status instead of a wall of
 * empty boxes.
 */
export function Skeleton({
  width = "100%",
  height = "1rem",
}: {
  width?: string | undefined;
  height?: string | undefined;
}) {
  return (
    <span className={styles.skeleton} style={{ inlineSize: width, blockSize: height }} aria-hidden="true" />
  );
}
